import {
  ProjectMapTemplate,
  MilestoneTemplateUpdate,
  CreateMilestoneTemplateRequest,
} from '@beeboard/common';
import {
  checkAddApproverTemplate,
  checkAddIntermediateMilestoneTemplate,
  checkRemoveApproverTemplate,
  checkRemoveMilestoneTemplate,
  checkUpdateMilestoneTemplate,
  isUserTemplateEditorOrAbove,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useMilestoneTemplateStore } from './milestoneTemplateStore';
import { useProfileStore } from './profileStore';
import { useTemplateStore } from './templateStore';

export const useMilestoneTemplateRulesStore = defineStore(
  'milestoneTemplateRulesStore',
  {
    getters: {
      user() {
        return useProfileStore().profile;
      },
      template() {
        return (templateId: string): ProjectMapTemplate => {
          const template = useTemplateStore().template(templateId);

          return template;
        };
      },
      editorsTemplate() {
        return (templateId: string) => {
          const template = useTemplateStore().editorsTemplate(templateId);

          return template;
        };
      },
      milestone() {
        return (templateId: string, milestoneId: string) => {
          const milestone = useMilestoneTemplateStore().milestone(
            templateId,
            milestoneId,
          );

          return milestone;
        };
      },
      isIntermediateMilestone() {
        return (templateId: string, milestoneId: string) => {
          const isIntermediateMilestone =
            useMilestoneTemplateStore().isIntermediateMilestone(
              templateId,
              milestoneId,
            );

          return isIntermediateMilestone;
        };
      },
      milestonePhase() {
        return (templateId: string, milestoneId: string) => {
          const phase = useTemplateStore().milestonePhase(
            templateId,
            milestoneId,
          );

          return phase;
        };
      },
    },
    actions: {
      isUserTemplateEditorOrAbove(templateId: string) {
        return !isUserTemplateEditorOrAbove(
          this.user.id,
          this.template(templateId).owner,
          this.editorsTemplate(templateId),
        ).length;
      },
      checkAddMilestone(
        templateId: string,
        phaseId: string,
        payload: CreateMilestoneTemplateRequest,
      ) {
        return checkAddIntermediateMilestoneTemplate(
          this.user.id,
          this.template(templateId),
          phaseId,
          payload,
          this.editorsTemplate(templateId),
        );
      },
      checkUpdateMilestone(
        templateId: string,
        milestoneId: string,
        updateRequest: MilestoneTemplateUpdate,
      ) {
        return checkUpdateMilestoneTemplate(
          this.user.id,
          this.template(templateId),
          this.milestonePhase(templateId, milestoneId).id,
          updateRequest,
          milestoneId,
          this.editorsTemplate(templateId),
        );
      },
      checkRemoveMilestone(templateId: string, milestoneId: string) {
        return checkRemoveMilestoneTemplate(
          this.user.id,
          this.template(templateId),
          this.milestonePhase(templateId, milestoneId).id,
          milestoneId,
          this.editorsTemplate(templateId),
        );
      },
      checkAddApprover(
        templateId: string,
        milestoneId: string,
        approverId: string,
      ) {
        return checkAddApproverTemplate(
          this.user.id,
          this.template(templateId),
          this.milestonePhase(templateId, milestoneId).id,
          this.milestone(templateId, milestoneId),
          approverId,
          this.editorsTemplate(templateId),
        );
      },
      checkRemoveApprover(
        templateId: string,
        milestoneId: string,
        approverId: string,
      ) {
        return checkRemoveApproverTemplate(
          this.user.id,
          this.template(templateId),
          this.milestonePhase(templateId, milestoneId).id,
          this.milestone(templateId, milestoneId),
          approverId,
          this.editorsTemplate(templateId),
        );
      },
    },
  },
);
